import { ApolloClient, InMemoryCache } from '@apollo/client';
import { loadSelectedPortForRunnerPush } from '../cache/localStorage';



let clientInstance: ApolloClient<any> | null = null;
let currentPort: number | null = null;


export const getClientWithAdjustableURL = () => {
  const port = loadSelectedPortForRunnerPush() || 4000;
  
  console.log('🔍 Port from localStorage:', port);
  console.log('🔍 Current cached port:', currentPort);
  
  // Recreate client only if port has changed
  if (!clientInstance || currentPort !== port) {
    currentPort = port;
    clientInstance = new ApolloClient({
      uri: `http://localhost:${port}/graphql`,
      cache: new InMemoryCache(),
    });
    console.log(`Apollo client created/updated with port: ${port}`);
  }
  
  return clientInstance;
};